import React from 'react'
import Breadcrumb from './Breadcrumb';
import HeaderOne from '../../components/header/HeaderOne';
import Footer from '../../components/footer/Footer';
import BlogContent from './BlogContent'

function BlogDetails() {
  return (
	<>
	<HeaderOne/>
	<main>
	<Breadcrumb/>
	<BlogContent/>

	</main>
	<Footer/>
	</>
  )
}

export default BlogDetails